export default __webpack_public_path__ + "static/media/six.7e1a9519.jpg";